export default {
  state:{
    form:{},
      reason:[],
  },
  mutations:{
    formAdd(state,obj){
      state.form = obj;
    },
      reasonAdd(state,obj){
          state.reason = obj;
      },

    formEmpty(state){
      state.form = {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/form.js